export default "__VITE_ASSET__9e4f54a4__"